import { Flex } from 'foundations-components/components/Flex';
import { UnauthedHubSpotUserAvatar } from 'avatar-components/UnauthedHubSpotUserAvatar';
import { AvatarDisplay } from 'avatar-components/AvatarDisplay';
import formatName from 'I18n/utils/formatName';
import { AvatarPill } from 'deal-plans-lib/components/AvatarPill';
import { CountBadge, MAX_VISIBLE_INDIVIDUALS, useOwnerCandidateGroups } from 'deal-plans-lib';
import { useBrandName, useCompanyName } from '../../contexts/PortalPlatformDataContext';
import { useAvatarData } from '../../contexts/AvatarsContext';
import { useSellerLogoUrl } from '../../hooks/useSellerLogoUrl';
import { getAvatarUrl } from '../../utils/avatarUtils';
import { PORTAL_FULL_MIN_WIDTH, PORTAL_MID_MIN_WIDTH } from '../../constants/portalBreakpoints';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const avatarGroupStyle = {
  size: 'sm',
  marginInlineStart: '-100',
  borderWidth: '200',
  borderStyle: 'solid',
  borderColor: 'border-core-on-fill-default'
};
const companyAvatarStyle = {
  type: 'company',
  size: 'sm',
  borderWidth: '200',
  borderStyle: 'solid',
  borderColor: 'border-core-on-fill-default'
};
function renderSeller(seller) {
  return /*#__PURE__*/_jsx(UnauthedHubSpotUserAvatar, Object.assign({
    hubSpotUserEmail: seller.email,
    displayName: formatName({
      firstName: seller.firstName,
      lastName: seller.lastName
    }) || seller.email
  }, avatarGroupStyle), seller.ownerId);
}
function renderBuyer(contact, avatarResults) {
  return /*#__PURE__*/_jsx(AvatarDisplay, Object.assign({
    src: getAvatarUrl(avatarResults, 'CONTACT', contact.contactVid),
    displayName: formatName({
      firstName: contact.firstName,
      lastName: contact.lastName
    }) || contact.email,
    type: "contact"
  }, avatarGroupStyle), contact.contactVid);
}
function renderMembers(members, memberNames, isSmall, renderAvatar) {
  if (isSmall) {
    return /*#__PURE__*/_jsx(CountBadge, {
      size: "sm",
      count: members.length,
      names: memberNames
    });
  }
  const visible = members.slice(0, MAX_VISIBLE_INDIVIDUALS);
  const overflowCount = Math.max(0, members.length - MAX_VISIBLE_INDIVIDUALS);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [visible.map(renderAvatar), overflowCount > 0 && /*#__PURE__*/_jsx(CountBadge, {
      size: "sm",
      count: overflowCount,
      names: memberNames.slice(MAX_VISIBLE_INDIVIDUALS)
    })]
  });
}
export function HeaderAvatarGroup({
  ownerCandidates,
  dealPlanContacts,
  headerWidth
}) {
  var _ref, _useAvatarData$result, _useAvatarData, _buyerCompany$name, _buyerCompany$name2;
  const sellerBrandName = useBrandName();
  const sellerCompanyName = useCompanyName();
  const sellerDisplayName = (_ref = sellerBrandName !== null && sellerBrandName !== void 0 ? sellerBrandName : sellerCompanyName) !== null && _ref !== void 0 ? _ref : undefined;
  const sellerLogoUrl = useSellerLogoUrl();
  const avatarResults = (_useAvatarData$result = (_useAvatarData = useAvatarData()) === null || _useAvatarData === void 0 ? void 0 : _useAvatarData.results) !== null && _useAvatarData$result !== void 0 ? _useAvatarData$result : [];
  const {
    sellers,
    buyerCompany,
    sellerNames,
    buyerNames
  } = useOwnerCandidateGroups(ownerCandidates, dealPlanContacts);
  if (!ownerCandidates.length && !dealPlanContacts.length) {
    return null;
  }
  const isFull = headerWidth === undefined || headerWidth >= PORTAL_FULL_MIN_WIDTH;
  const isSmall = headerWidth !== undefined && headerWidth < PORTAL_MID_MIN_WIDTH;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    children: [sellers.length > 0 && /*#__PURE__*/_jsx(AvatarPill, {
      companyAvatar: /*#__PURE__*/_jsx(AvatarDisplay, Object.assign({
        src: sellerLogoUrl,
        displayName: sellerDisplayName
      }, companyAvatarStyle)),
      companyName: isFull ? sellerDisplayName : undefined,
      children: renderMembers(sellers, sellerNames, isSmall, renderSeller)
    }), dealPlanContacts.length > 0 && /*#__PURE__*/_jsx(AvatarPill, {
      companyAvatar: /*#__PURE__*/_jsx(AvatarDisplay, Object.assign({
        src: buyerCompany ? getAvatarUrl(avatarResults, 'COMPANY', buyerCompany.companyId) : undefined,
        displayName: (_buyerCompany$name = buyerCompany === null || buyerCompany === void 0 ? void 0 : buyerCompany.name) !== null && _buyerCompany$name !== void 0 ? _buyerCompany$name : 'Buyer'
      }, companyAvatarStyle)),
      companyName: isFull ? (_buyerCompany$name2 = buyerCompany === null || buyerCompany === void 0 ? void 0 : buyerCompany.name) !== null && _buyerCompany$name2 !== void 0 ? _buyerCompany$name2 : 'Buyer' : undefined,
      children: renderMembers(dealPlanContacts, buyerNames, isSmall, contact => renderBuyer(contact, avatarResults))
    })]
  });
}